// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e4f52b20","453":"53ea5490"}[chunkId] + ".chunk.js";
};